module.exports = __webpack_public_path__ + "img/ceilometro.878c7ba1.webp";